/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface WaterFlowGraphRequest
 */
export interface WaterFlowGraphRequest {
  /**
   * simulation time in seconds
   */
  startTime: number;
  /**
   * Maximum number of points of history to return
   */
  historyPointsLimit?: number;
  /**
   * Subscribe for new results during simulation
   */
  subscribe: boolean;
  /**
   * Max number of items per second for subscription
   */
  subscribeRateLimit?: number;
  /**
   *
   */
  lineId: number;
}

/**
 * Check if a given object implements the WaterFlowGraphRequest interface.
 */
export function instanceOfWaterFlowGraphRequest(value: object): value is WaterFlowGraphRequest {
  if (
    (!("startTime" in (value as Record<string, any>)) &&
      !("start_time" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["startTime"] === undefined &&
      (value as Record<string, any>)["start_time"] === undefined)
  )
    return false;
  if (!("subscribe" in value) || value["subscribe"] === undefined) return false;
  if (
    (!("lineId" in (value as Record<string, any>)) &&
      !("line_id" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["lineId"] === undefined &&
      (value as Record<string, any>)["line_id"] === undefined)
  )
    return false;
  return true;
}

export function WaterFlowGraphRequestFromJSON(json: any): WaterFlowGraphRequest {
  return WaterFlowGraphRequestFromJSONTyped(json, false);
}

export function WaterFlowGraphRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): WaterFlowGraphRequest {
  if (json == null) {
    return json;
  }
  return {
    startTime: json["start_time"],
    historyPointsLimit:
      json["history_points_limit"] == null ? undefined : json["history_points_limit"],
    subscribe: json["subscribe"],
    subscribeRateLimit:
      json["subscribe_rate_limit"] == null ? undefined : json["subscribe_rate_limit"],
    lineId: json["line_id"],
  };
}

export function WaterFlowGraphRequestToJSON(json: any): WaterFlowGraphRequest {
  return WaterFlowGraphRequestToJSONTyped(json, false);
}

export function WaterFlowGraphRequestToJSONTyped(
  value?: WaterFlowGraphRequest | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    start_time: value["startTime"],
    history_points_limit: value["historyPointsLimit"],
    subscribe: value["subscribe"],
    subscribe_rate_limit: value["subscribeRateLimit"],
    line_id: value["lineId"],
  };
}
